module.exports = __webpack_public_path__ + "img/question.87f0a78d.svg";